const optionsEn = ['Movies', 'Music', 'Books', 'Travel', 'Food', 'Sports', 'Home', 'Gardening', 'Photography', 'Parenting', 'Relationships', 'Crafts', 'Beauty', 'Humor', 'Spirituality', 'Design', 'Writing']
const optionsHe = ['סרטים', 'מוזיקה', 'ספרים', 'טיולים', 'אוכל', 'ספורט', 'בית', 'גינון', 'צילום', 'הורות', 'יחסים', 'אמנות', 'יופי', 'הומור', 'רוחניות', 'עיצוב', 'כתיבה']

export function MockFilter({ previewLan }) {
    const options = previewLan === 'he' ? optionsHe : optionsEn

    return <div className="mock-filter">
        <div className="filter-option selected">{previewLan === 'he' ? 'הכל' : 'All'}</div>
        {options.map((option, idx) => <div className="filter-option" key={idx}>{option}</div>)}
    </div>
}